/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
*/

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/datepicker.js';

require('./bootstrap');

require('./tree');

import Chart from 'chart.js/auto';
window.Chart = Chart;
Chart.defaults.plugins.legend.rtl = true;
Chart.defaults.plugins.legend.position = 'right';
Chart.defaults.plugins.legend.align = 'right';
Chart.defaults.plugins.legend.labels.boxWidth = 12;
Chart.defaults.plugins.legend.labels.boxHeight = 12;
Chart.defaults.plugins.title.display = true;
Chart.defaults.plugins.title.font.size = 15;
Chart.defaults.plugins.title.font.weight = 'bolder';
Chart.defaults.plugins.title.padding = 10;
Chart.defaults.font.family = "IRANSansFa";
Chart.defaults.locale = "fa";
window.chart_default_config = {
    legend_font: {
        weight: 'bolder',
        size: 15
    }
};

String.prototype.toPersianDigit= function(){
    var id= ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
     return this.replace( /[0-9]/g, function(w){return id[+w]} );
};

String.prototype.toEnglishDigit = function() {
    var find = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    var replace = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var replaceString = this;
    var regex;
    for (var i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        replaceString = replaceString.replace(regex, replace[i]);
    }
    return replaceString;
};

String.prototype.limit = function (limit=100) {
    return this.slice(0, limit) + (
        this.length > limit ? '...' : ''
    );
}

String.prototype.getCellText = function () {
    var text = this.trim();
    if (text.startsWith('<') && text.endsWith('>')) {
        return this;
    }
    return '<span data-toggle="tooltip" title="' + text + '">' + text.limit(20) + '</span>';
}

// disappear bootstrap tooltips after 2 seconds
var tooltip  = $('[data-toggle="tooltip"]');
tooltip.on('mouseenter',function(){
    var that = $(this)
    that.tooltip('show');
    setTimeout(function(){
        that.tooltip('hide');
    }, 2000);
});
tooltip.on('mouseleave',function(){
    $(this).tooltip('hide');
});

window.captcha_timer = null;

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

// required for ajax request
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

String.prototype.sanitize = function ()
{
    return this.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .replace(/ on\w+="[^"]*"/gi, '');
}

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
